import { Colour } from "react-migration/domains/constraints/designation/style/colours";

export const POINT_SELECTION_BUFFER_RADIUS_METERS = 50;
export const SELECTION_RADIUS_FILL_COLOUR = Colour.BLUE_20;
export const SELECTION_RADIUS_STROKE_COLOUR = Colour.BLUE_60;
